<template>
    <div class="col-lg-4 col-md-6 col-sm-12 result mb-4">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-12 d-flex justify-content-between">
                        <div class="details row" @click="viewJourneyDetails()">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-lg-4 text-left">
                                        <p class="mb-1 px-2">To:</p>
                                    </div>
                                    <div class="col-lg-8 text-right pl-1">
                                        <p class="mb-1 px-2"><strong>{{this.payload.destination_address}}</strong> </p>
                                    </div>
                                    <div class="col-12">
                                        <hr class="my-2">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-lg-4 text-left">
                                        <p class="mb-1 px-2">From:</p>
                                    </div>
                                    <div class="col-lg-8 text-right">
                                        <p class="mb-1 px-2"><strong>{{this.payload.origin}}</strong> </p>
                                    </div>
                                    <div class="col-12">
                                        <hr class="my-2">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12 d-flex">
                                        <div class="col-6 text-left">
                                            <b-badge  v-if="payload.is_return" class="position-static journey-type-pill" pill >Return</b-badge>
                                            <b-badge  v-if="!payload.is_return" class="position-static journey-type-pill" pill >Single</b-badge>
                                        </div>
                                         <div class="col-6 text-right">
                                           {{payload.cost}}
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-2">
                                <div class="row">
                                    <div class="col-lg-12 text-center">
                                        <p class="mb-1 px-2"><strong>{{payload.out_date}}</strong> </p>
                                        <hr class="my-2">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mediums col-12">
                                        <div class="mediums d-flex align-items-center">
                                            <!-- icons go here -->
                                            <div class="indicators col-12 text-center d-inline-block">
                                                <div class="col-12 mb-2">
                                                    <div v-for="(icon, index) in payload.stages.depart" :key="index" class="medium text-center d-inline-block mr-2">
                                                        <svg-icon v-if="icon === 'own car'" name="car" aria-label="transport-icon" width="auto" height="1.5em"></svg-icon>
                                                        <svg-icon v-if="index != 0" aria-label="dotted line" class="mr-1" name="dotted-line" width="20px" height="auto"></svg-icon>
                                                          <svg-icon v-if="icon !== 'own car'" :name="icon" aria-label="transport-icon" width="auto" height="1.5em"></svg-icon>
                                                    </div>
                                                </div>
                                                <div class="indicator-item d-inline-block pr-1">
                                                    <h3>Leave</h3>
                                                    <h3>{{payload.out_time}}</h3>
                                                </div>
                                                <div class="indicator-item d-inline-block px-1">
                                                    <svg-icon class="" name="dotted-line" width="40"></svg-icon>
                                                </div>
                                                <div class="indicator-item d-inline-block px-1">
                                                    <h3>Time</h3>
                                                    <h3>{{payload.duration_depart.text}}</h3>
                                                </div>
                                                <div class="indicator-item d-inline-block px-1">
                                                    <svg-icon class="" name="dotted-line" width="40"></svg-icon>
                                                </div>
                                                <div class="indicator-item d-inline-block pl-1">
                                                    <h3>Arrive</h3>
                                                    <h3>{{payload.out_arrive_time}}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr>
                                </div>
                                <hr>
                                <!-- return section only-->
                                <div v-if="payload.is_return">
                                    <div class="row">
                                        <div class="col-lg-12 text-center">
                                            <p class="mb-1 px-2"><strong>{{payload.return_date}}</strong> </p>
                                            <hr class="my-2">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="mediums col-12">
                                            <div class="mediums d-flex align-items-center">
                                                 <!-- icons go here -->
                                                <div class="indicators col-12 text-center d-inline-block">
                                                    <div class="col-12 mb-2">
                                                    <div v-for="(icon, index) in payload.stages.depart" :key="index" class="medium text-center d-inline-block mr-2">
                                                        <svg-icon v-if="icon === 'own car'" name="car" aria-label="transport-icon" width="auto" height="1.5em"></svg-icon>
                                                        <svg-icon v-if="index != 0" aria-label="dotted line" class="mr-1" name="dotted-line" width="20px" height="auto"></svg-icon>
                                                        <svg-icon v-if="icon !== 'own car'" :name="icon" aria-label="transport-icon" width="auto" height="1.5em"></svg-icon>
                                                    </div>
                                                </div>
                                                    <div class="indicator-item d-inline-block pr-1">
                                                        <h3>Leave</h3>
                                                        <h3>{{payload.return_time}}</h3>
                                                    </div>
                                                    <div class="indicator-item d-inline-block px-1">
                                                        <svg-icon class="" name="dotted-line" width="40"></svg-icon>
                                                    </div>
                                                    <div class="indicator-item d-inline-block px-1">
                                                        <h3>Time</h3>
                                                        <h3>{{payload.duration_return.text}}</h3>
                                                    </div>
                                                    <div class="indicator-item d-inline-block px-1">
                                                        <svg-icon class="" name="dotted-line" width="40"></svg-icon>
                                                    </div>
                                                    <div class="indicator-item d-inline-block pl-1">
                                                        <h3>Arrive</h3>
                                                        <h3>{{payload.return_arrive_time}}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                    </div>
                                    <hr>
                                </div>
                                <!--end of return -->
                            </div>
                        </div>
                    </div>
                    <div class="d-flex  col-12 justify-content-end align-items-center">
                        <div class="wrapper">
                            <a @click="planAgain()"><strong>Plan Again</strong></a>
                        </div>
                        <div class="wrapper">
                            <svg-icon class="ml-2 forward-icon" name="forward"  width="8" height="auto"></svg-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'search-item',
    props: ['payload'],
    components: {

    },
    data() {
        return {
            hash: this.$route.params.hash,
        }
    },
    methods: {
        planAgain() {
            this.$router.push({
                name: 'Home',
                params: {
                    origin: this.payload.origin_address,
                    destination: this.payload.destination_address,
                },
            })
        },
        viewJourneyDetails() {
            this.$router.push({
                name: 'Journey',
                params: {
                    hash: this.payload.hash,
                    journeyId: this.payload.journey_id,
                },
                query: {
                    show: true,
                },
            })
        },
    },
    computed: {
        isJourneySaved() {
            return this.currentJourney.user_status === 'saved'
        },
    },
}
</script>
<style>
.journey-type-pill{
    border-radius: 20px !important
}
</style>
